@if (isLoading | async) {
  <loading-spinner class="spinner green loader-big no-padding"></loading-spinner>
} @else {
  <ng-container>
    @if (isTrxMarginTradingFee()) {
      <div class="transaction-list-detail__margin-trading-banner">
        <p class="banner-title">{{ "tx_history_margin_trading_banner_title" | translate }}</p>
        <p class="banner-message" [innerHtml]="'tx_history_margin_trading_banner_message' | translate"></p>
      </div>
    }
    <div class="transaction-list-detail__background" [class.has-banner]="isTrxMarginTradingFee()">
      <div class="transaction-list-detail__column-left" [ngClass]="{ 'mod-bank-transfer': isBankTransfer() }">
        <div class="transaction-list-detail__recipient-information">
          <div class="mod-header">{{ "details_tx_item" | translate }}</div>
          <div>
            @if (getFrom && getFrom.length) {
              <div class="mod-item">
                <span [ngClass]="getSmallBoxCss()">{{ "from_tx_item" | translate }}:</span>
                <span
                  class="{{ getLargeBoxCss() }}"
								[ngClass]="{
									'mod-wallet-link': canNavigateToWallet(true, isIndexClaim)
								}"
                  (click)="!isIndexClaim && goToWallet()">
                  @if (shouldDisplayNewCryptoTransactionData && fromField) {
                    <span>{{ fromField }}</span>
                  } @else {
                    <ng-content select="[fromWallet]"></ng-content>
                    @if (isDeletedWallet()) {
                      <span>({{ "deleted" | translate }})</span>
                    }
                  }
                </span>
              </div>
            }
            @if (shouldDisplayNewCryptoTransactionData) {
              @if (shouldDisplayTo) {
                <div class="mod-item">
                  <span [ngClass]="getSmallBoxCss()">{{ "to_tx_item" | translate }}:</span>
                  <span class="{{ getLargeBoxCss() }} mod-date title-note">
                    <span class="color-text button-weight font-size-13">{{
                      transactionInfoStatus.to
                    }}</span>
                  </span>
                </div>
              }
            }
            <ng-template #toWalletTemplate>
              @if (getTo && getTo.length) {
                <div class="mod-item">
                  <span [ngClass]="getSmallBoxCss()">{{ "to_tx_item" | translate }}:</span>
                  <span
                    class="{{ getLargeBoxCss() }}"
                    [tabIndex]="0"
									[ngClass]="{
										'mod-wallet-link': canNavigateToWallet(false, isIndexClaim)
									}"
                    (keydown.enter)="!isIndexClaim && goToWallet(false)"
                    (click)="!isIndexClaim && goToWallet(false)">
                    <ng-content select="[toWallet]"></ng-content>
                    @if (isDeletedWallet(false)) {
                      <span>({{ "deleted" | translate }})</span>
                    }
                  </span>
                </div>
              }
            </ng-template>
            @if (
              (transactionType === 'deposit' || transactionType === 'withdrawal') &&
              !isFiatTx() &&
              networkName?.length > 0
              ) {
              <div class="mod-item">
                <span class="mod-flex-25">{{ "network" | translate }}:</span>
                <span class="mod-flex-75">
                  {{ "name_network" | translate: [networkName] }}
                </span>
              </div>
            }
            @if (transactionInfoStatus.wallet_host) {
              <div class="mod-item">
                <span [ngClass]="getSmallBoxCss()">{{ "wallet_host" | translate }}:</span>
                <span class="{{ getLargeBoxCss() }} mod-date title-note">
                  <span class="color-text button-weight font-size-13">{{
                    transactionInfoStatus.wallet_host
                  }}</span>
                </span>
              </div>
            }
            @if (!isFiatDebitCardTx()) {
              <ng-container [ngTemplateOutlet]="toWalletTemplate"></ng-container>
              @if (hasExternalTxId()) {
                <div class="mod-item">
                  <span class="mod-flex-25">{{ "ID" | translate }}:</span>
                  <span class="mod-flex-75">
                    <ng-content select="[transactionId]"></ng-content>
                  </span>
                </div>
              }
              @if (isDividend()) {
                <div class="mod-item">
                  <span [ngClass]="getSmallBoxCss()">{{ "trade_summary_step_1_buy" | translate }}:</span>
                  <span
                    class="{{ getLargeBoxCss() }}"
                    [ngClass]="{ 'mod-wallet-link': !isCashPlus }"
                    (click)="goToDividendAsset()">
                    <ng-content select="[fromAsset]"></ng-content>
                  </span>
                </div>
              }
              <div class="mod-item">
                <span class="mod-flex-25">{{ "transaction_type_tx_item" | translate }}:</span>
                <span class="mod-flex-75 title-note">
                  <span class="title-note-inner mod-tag mr-5">
                    {{ transactionType + "_tx_item" | translate }}
                  </span>
                </span>
              </div>
            } @else {
              @if (!isDebitCardWithdrawal()) {
                <ng-container [ngTemplateOutlet]="toWalletTemplate">
                </ng-container>
              }
              @if (hasMerchantDetails(transaction)) {
                <div class="mod-item pb-30">
                  <span class="mod-flex-33 wrap-normal hyphens-0">
                    {{ "debit_card_tx_recipient" | translate }}:
                  </span>
                  <div class="flex flex-col color-black-dark font-size-14 mod-flex-67 flow-hidden">
                    <div class="mod-flex-67 title-note mb-5 font-medium wrap-normal">
                      {{ transaction.getMerchantDetails().getLocation() }}
                    </div>
                    <div class="mod-flex-67 title-note wrap-normal">
                      {{ transaction.getMerchantDetails().getStreet() }}
                    </div>
                    <div class="mod-flex-67 title-note wrap-normal">
                      {{ transaction.getMerchantDetails().getCity() }}{{ getDebitCardTxCountry() }}
                    </div>
                  </div>
                </div>
              }
            }
            @if (shouldDisplayNewCryptoTransactionData || isTrxCryptoMerger()) {
              <div class="mod-item">
                <span [ngClass]="getSmallBoxCss()">{{ "status" | translate }}:</span>
                <span class="{{ getLargeBoxCss() }} title-note">
                  <span class="title-note-inner mr-5" [ngClass]="transactionInfoStatus.color">
                    {{ transactionInfoStatus.status }}
                  </span>
                  @if (displayRejectedInfoTooltip) {
                    <span
                      class="bpi__icon-info text-blue font-size-13 mod-info"
                      [bp-tooltip]="'rejected_status_tooltip' | translate"
                      position="top">
                    </span>
                  }
                </span>
              </div>
              @if (transactionInfoStatus.wallet_host) {
                <div class="mod-item">
                  <span [ngClass]="getSmallBoxCss()">{{ "wallet_host" | translate }}:</span>
                  <span class="{{ getLargeBoxCss() }} mod-date title-note">
                    <span class="color-text button-weight font-size-13">{{
                      transactionInfoStatus.wallet_host
                    }}</span>
                  </span>
                </div>
              }
              @if (transactionInfoStatus.destination_tag_value) {
                <div class="mod-item">
                  <span [ngClass]="getSmallBoxCss()">{{
                    transactionInfoStatus.destination_tag_type | translate
                  }}</span>
                  <span class="{{ getLargeBoxCss() }} mod-date title-note">
                    <span class="color-text button-weight font-size-13">{{
                      transactionInfoStatus.destination_tag_value
                    }}</span>
                  </span>
                </div>
              }
              @if (transactionInfoStatus.walletAddress) {
                <div class="mod-item">
                  <span [ngClass]="getSmallBoxCss()">{{ "wallet_addresses" | translate }}:</span>
                  <span class="{{ getLargeBoxCss() }} mod-date title-note">
                    <span class="color-text button-weight font-size-13">{{
                      transactionInfoStatus.walletAddress
                    }}</span>
                  </span>
                </div>
              }
            }
            <div class="mod-item">
              <span [ngClass]="getSmallBoxCss()">{{ "date_tx_item" | translate }}:</span>
              <span class="{{ getLargeBoxCss() }} mod-date title-note">
                <span class="color-text button-weight font-size-13">{{
                  transactionDate | bp_date
                }}</span>
              </span>
            </div>
            @if (isDebitCardTx() && transaction.tax_withheld?.fiat_amount_after_tax) {
              <div
                class="mod-item">
                <div class="mod-flex-33">
                  {{ "details_you_paid" | translate }}
                </div>
                <div class="flex flex-col color-black-dark">
                  <span class="mod-flex-67 title-note button-weight">
                    {{
                    transaction.tax_withheld.fiat_amount_after_tax
                    | fiat_precision_symbol: { id: fiat?.getId(), symbol: true }
                    }}
                  </span>
                </div>
              </div>
            }
            @if (isDebitCardTx() && transaction.tax_withheld?.amount_fiat) {
              <div class="mod-item">
                <div class="mod-flex-33">
                  {{ "details_tax_withheld" | translate }}
                </div>
                <div class="flex flex-col color-black-dark">
                  <span class="mod-flex-67 title-note button-weight">
                    {{
                    transaction.tax_withheld.amount_fiat
                    | fiat_precision_symbol: { id: fiat?.getId(), symbol: true }
                    }}
                    <span class="bpi__icon-info" (click)="goToTaxInfo()"> </span>
                  </span>
                </div>
              </div>
            }

            @if (trxTaxesInfoVM$ | async; as taxStatus) {
              @if (taxStatus.declaredTrx.status === taxesTrxTypes.Declared) {
                <div
                  class="mod-item"
                  [@fadeIn]="true">
                  <ng-container taxInfoTitle>
                    <span class="mod-flex-25">{{ "transaction_details_tax_info" | translate }}:</span>
                  </ng-container>
                  <ng-container taxInfo>
                    <div class="declaration-details-area mod-flex-75">
                      @for (declaration of taxStatus.declaredTrx.declarations; track declaration) {
                        <div
                          class="declaration-date mod-date title-note"
                          >
                          <div class="declaration-details">
                            <div class="declaration-price">
                              {{
                              declaration.amount
                              | tradable_precision_symbol: { id: getCurrencyId() }
                              }}
                            </div>
                            @if (
                              declaration.purchase_date_from && declaration.purchase_date_to
                              ) {
                              <div
                                class="range-date-declaration"
                                >
                                {{
                                (declaration.purchase_date_from === declaration.purchase_date_to
                                ? "transaction_details_tax_info_buy_date_range_singular"
                                : "transaction_details_tax_info_buy_date_range"
                                )
                                | translate
                                : [
                                declaration.purchase_date_from
                                | bp_date
                                : {
                                date: ["day", "month", "year"],
                                time: []
                                },
                                declaration.purchase_date_from ===
                                declaration.purchase_date_to
                                ? null
                                : (declaration.purchase_date_to
                                | bp_date
                                : {
                                date: [
                                "day",
                                "month",
                                "year"
                                ],
                                time: []
                                }),
                                declaration.purchase_price
                                | fiat_precision_symbol
                                : {
                                id: taxStatus.declaredTrx
                                .fiatId,
                                symbol: true
                              }
                              ]
                              }}
                            </div>
                          }
                          @if (declaration.bought_before_cutoff_point) {
                            <div>{{
                              "tax_information_exempt_condition" | translate
                            }}</div>
                          }
                          @if (declaration.price_or_date_unknown) {
                            <div>{{
                              "tax_information_unknown" | translate
                            }}</div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </ng-container>
              </div>
            }
          }

          <div class="mod-item">
            <ng-content select="[taxInfoTitle]"></ng-content>
            <ng-content select="[taxInfo]"></ng-content>
          </div>

          @if (
            isLeveragedTx() &&
            !this.isFiatTransaction() &&
            (leveragedTokenBaseSymbol | async); as baseSymbol
            ) {
            <div class="mod-item">
              <span [ngClass]="getSmallBoxCss()" class="mod-leverage"
                >{{ "leveraged_token_starting_position" | translate }}:</span
                >
                <span class="{{ getLargeBoxCss() }} mod-date title-note">
                  <span class="color-text button-weight font-size-13">
                    {{
                    (transaction.getStartingBorrow() || transaction.getTradeStartingBorrow()) +
                    " " +
                    baseSymbol
                    }}
                  </span>
                </span>
              </div>
              <div class="mod-item">
                <span [ngClass]="getSmallBoxCss()" class="mod-leverage">
                  {{ "leveraged_token_closing_position" | translate }}:
                </span>
                <span class="{{ getLargeBoxCss() }} mod-date title-note">
                  <span class="color-text button-weight font-size-13">
                    {{
                    (transaction.getClosingBorrow() || transaction.getTradeClosingBorrow()) +
                    " " +
                    baseSymbol
                    }}
                  </span>
                </span>
              </div>
            }

            @if (+getTax().amount_fiat > 0) {
              @if (capitalGainsTaxes$ | async; as vmCG) {
                <div class="mod-item">
                  <span class="mod-flex-25">{{
                    (vmCG.capitalGain >= 0 ? "capital_gain" : "capital_loss") | translate
                  }}</span>
                  @if (!vmCG.isError && vmCG.capitalGain !== null) {
                    <ng-template
                      [ngTemplateOutlet]="capitalGains"
                    [ngTemplateOutletContext]="{ value: vmCG.capitalGain }"></ng-template>
                  }
                  @if (vmCG.isError || vmCG.capitalGain === null) {
                    <ng-container
                    [ngTemplateOutlet]="isError"></ng-container>
                  }
                </div>
                <div class="mod-item">
                  <span class="mod-flex-25">{{ "taxable_amount" | translate }}</span>
                  @if (!vmCG.isError && vmCG.capitalGain !== null) {
                    <ng-template
                      [ngTemplateOutlet]="capitalGains"
                    [ngTemplateOutletContext]="{ value: vmCG.taxableAmount }"></ng-template>
                  }
                  @if (vmCG.isError || vmCG.capitalGain === null) {
                    <ng-container
                    [ngTemplateOutlet]="isError"></ng-container>
                  }
                </div>
              }
              <div class="mod-item">
                <span class="mod-flex-25">{{ "tw_tax_amount" | translate }}:</span>
                <div class="mod-flex-75 tax-amount">
                  <span>{{
                    getTax()?.amount_fiat
                    | fiat_precision_symbol: { id: getTax()?.fiat_id.toString(), symbol: true }
                    }}</span
                    ><span class="bpi__icon-info taxes-tooltip" (click)="goToTaxInfo()"></span
                  ></div>
                </div>
                <div class="mod-item">
                  <span class="mod-flex-25">{{ "amount_after_tx" | translate }}:</span>
                  <span class="mod-flex-75 tax-amount">{{
                    getTax()?.fiat_amount_after_tax
                    | fiat_precision_symbol: { id: getTax()?.fiat_id.toString(), symbol: true }
                  }}</span>
                </div>
              }
              <!-- Best Fees OR Spread for Stocks/ETFs   -->

              @if (isSecurityToken()) {
                <div class="mod-item">
                  <span class="mod-flex-25">{{ "fee" | translate }}</span>
                  <span class="mod-flex-75"
                    >{{
                    getStockSpread()
                    | fiat_precision_symbol
                    : { id: txFiat?.getId(), symbol: true, currencies: [txFiat] }
                    }}
                  </span>
                </div>
              }

              <!-- trade fee for crypto -->
              @if (isTradeFeeAvailableForCrypto$ | async) {
                @if (fee?.is_fee_transparent) {
                  <div class="mod-item">
                    <div class="mod-flex-25">{{ "trans_fee_trade" | translate }}:</div>
                    <div class="mod-flex-75">
                      @if (transaction.isVsnFeeCollection()) {
                        <span class="fee-vsn mr-5">{{
                          "pay_fees_with_vsn" | translate | uppercase
                        }}</span>
                      }
                      @if (fee?.fee_amount_in_fiat || fee?.fee_percentage) {
                        <!-- if fee exist -->
                        @if (fee?.fee_percentage === 0) {
                          <span class="fee-free mr-5">{{ "free" | translate }}</span
                            ><span>({{ fee.fee_percentage | percent: "1.2-2" }})</span>
                          } @else {
                            <span class="color-text">{{
                              fee.fee_amount_in_fiat
                              | fiat_precision_symbol
                              : {
                              id: txFiat?.getId(),
                              symbol: true,
                              currencies: [txFiat]
                            }
                          }}</span>
                          <!-- fee percentage should NOT be displayed for RS -->
                          @if (!isRealSecurities()) {
                            &nbsp;<span>
                            ({{ fee.fee_percentage / 100 | percent: "1.2-2" }})</span
                            >
                          }
                        }
                        <!-- if fee exist -->
                      } @else if (
                        feeInSwapTrade?.fee_amount_in_fiat || feeInSwapTrade?.fee_percentage
                        ) {
                        <!-- if fee in swap exists -->
                        @if (feeInSwapTrade?.fee_percentage === 0) {
                          <span class="fee-free mr-5">{{ "free" | translate }}</span
                            ><span>({{ feeInSwapTrade.fee_percentage | percent: "1.2-2" }})</span>
                          } @else {
                            <span>{{
                              feeInSwapTrade.fee_amount_in_fiat
                              | fiat_precision_symbol
                              : {
                              id: txFiat?.getId(),
                              symbol: true,
                              currencies: [txFiat]
                            }
                            }}</span
                            >&nbsp;<span
                            >({{
                            feeInSwapTrade.fee_percentage / 100 | percent: "1.2-2"
                            }})</span
                            >
                          }
                          <!-- if fee in swap exists -->
                        } @else if (feeInCardTx?.fee_amount_in_fiat || feeInCardTx?.fee_percentage) {
                          <!-- if fee in cardTX exists -->
                          @if (+feeInCardTx?.fee_percentage === 0) {
                            <span class="fee-free mr-5">{{ "free" | translate }}</span
                              ><span>({{ feeInCardTx.fee_percentage | percent: "1.2-2" }})</span>
                            } @else {
                              <span>{{
                                feeInCardTx.fee_amount_in_fiat
                                | fiat_precision_symbol
                                : {
                                id: txFiat?.getId(),
                                symbol: true,
                                currencies: [txFiat]
                              }
                              }}</span
                              >&nbsp;<span
                              >({{ +feeInCardTx.fee_percentage / 100 | percent: "1.2-2" }})</span
                              >
                            }
                            <!-- if fee in cardTX exists -->
                          } @else {
                            {{ "fee_transparency_tx_load_error" | translate }}
                          }
                        </div>
                      </div>
                    }
                  }
                  <!-- trade fee for crypto -->

                  @if (transaction.isVsnFeeCollection()) {
                    <div class="mod-item">
                      <span class="mod-flex-25">{{ "vsn_used_tx_item" | translate }}:</span>
                      <div class="mod-flex-75 color-text">
                        <ng-content select="[vsnUsed]"></ng-content>
                      </div>
                    </div>
                    <div class="mod-item">
                      <span class="mod-flex-25">{{ "vsn_price_tx_item" | translate }}:</span>
                      <div class="mod-flex-75 color-text">
                        <ng-content select="[vsnPrice]"></ng-content>
                      </div>
                    </div>
                  }

                  <!-- RS fields -->
                  @if (isRealSecurities()) {
                    <div class="mod-item">
                      <span class="mod-flex-25">{{ "asset_details_isin_title" | translate }}:</span>
                      <span class="mod-flex-75 color-text">
                        {{ getISIN() }}
                      </span>
                    </div>
                    <div class="mod-item">
                      <span class="mod-flex-25">{{ "transactions_detail_exchange" | translate }}:</span>
                      <span class="mod-flex-75 color-text">
                        {{ getExchange() }}
                      </span>
                    </div>
                    <div class="mod-item">&nbsp; </div>
                  }

                  @if ((paidFeesWithBest() || hasSpread()) && !isEarnOnFiatElement(transaction)) {
                    <div
                      class="mod-item"
                      >
                      <span [ngClass]="getSmallBoxCss()">{{ getFeeText() | translate }}:</span>
                      <!-- Fees paid with BEST -->
                      @if (paidFeesWithBest()) {
                        <span
                          class="mod-item flex-col {{ getLargeBoxCss() }}"
								[ngClass]="{
									'hover-pointer': !isBestMetalStorageFee()
								}"
                          (click)="openBestDetails()">
                          @if (!transaction?.getIsBfc()) {
                            <span
                              class="button-weight font-size-13"
									[ngClass]="{
										'color-primary': !isBestMetalStorageFee(),
										'color-text': isBestMetalStorageFee()
									}">
                              {{ "fees_paid_with_best_tx" | translate }}
                            </span>
                          }
                          <span
                            class="button-weight line-height-em font-size-13 white-space-normal"
									[ngClass]="{
										'color-primary': !isBestMetalStorageFee(),
										'color-text': isBestMetalStorageFee(),
										'pt-5': transaction?.getIsBfc()
									}">
                            {{
                            getBestFee()
                            | tradable_precision_symbol: { id: getBestId(), ignorePrecision: true }
                            }}
                            &#64;
                            {{
                            getBestTransactionPrice()
                            | fiat_precision_symbol
                            : {
                            id: getBestTxFiat()?.getId(),
                            symbol: true,
                            currencies: [getBestTxFiat(), getBestId() | tradable]
                          }
                          }}
                          @if (showHistoricPrice()) {
                            <span>
                              {{
                              "bfc_historic_price_addition"
                              | translate
                              : [
                              getBestTransactionPrice(false)
                              | fiat_precision_symbol
                              : {
                              id: getBestTxFiat()?.getId(),
                              symbol: true,
                              currencies: [
                              getBestTxFiat(),
                              getBestId() | tradable
                              ]
                            }
                            ]
                            }}
                          </span>
                        }
                        ,
                        @if (!hasSpread()) {
                          <span>
                            {{
                            "bfc_effective_discount_percentage" | translate: [getBestDiscountPercent()]
                            }}
                          </span>
                        } @else {
                          <span>
                            {{ "percentage_reduced_spread" | translate: [getBestDiscountPercent()] }}
                          </span>
                        }
                        <!-- Fees paid with BEST: different text for Stocks/ETFs -->
                      </span>
                    </span>
                  } @else {
                    <span class="mod-item flex-col {{ getLargeBoxCss() }}">
                      <span>
                        {{
                        getStockSpread()
                        | fiat_precision_symbol
                        : { id: txFiat?.getId(), symbol: true, currencies: [txFiat] }
                        }}
                      </span>
                    </span>
                  }
                  <!-- Fees NOT paid with BEST, but it's a Stock/ETF, so we gonna show the spread regardless -->
                </div>
              }
              <ng-content select="[transactionLogo]"></ng-content>
              @if (isDebitCardTx()) {
                <div class="flex flex-row pt-30">
                  <div class="justify-center items-center min-w-18">
                    <img
                      [src]="'/assets/images/icon-black-inverted-info.svg'"
                      [alt]="'info_icon_alt_text' | translate" />
                  </div>
                  <div class="pl-10 pr-10 font-size-12 color-black-dark line-height-em hyphens-0">
                    {{ "debit_card_tx_more_info" | translate }}
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="transaction-list-detail__column-right">
          @if (showPurposeText()) {
            <div class="transaction-list-detail__purpose-text">
              {{ referenceLocaKey | translate }}: {{ txPurposeText }}
            </div>
          }
          @if (trxTaxesInfoVM$ | async; as taxStatus) {
            <div [@fadeIn]="true" class="prompt-class">
              @if (taxStatus.isUserEligible && taxStatus.declaredTrx.status === taxesTrxTypes.Undeclared) {
                <tax-declaration-prompt
                  (onButtonClicked)="onShareTrxClicked()">
                </tax-declaration-prompt>
              }
            </div>
          }
          <!-- show tax refund related transaction for refund -->
          @if (showTaxRefundRelatedTx$ | async; as taxRefundRelatedTx) {
            @if (taxRefundRelatedTx?.enabled && taxRefundRelatedTx?.type === 'refund') {
              <div
                class="mod-exchange tax-refund-link"
                >
                <a
							(click)="
								openTaxRefundRelatedTx(
									taxRefundRelatedTx?.fiatWalletId,
									taxRefundRelatedTx?.relatedTxId
								)
							"
                  >{{ "swap_show_more_tx_item" | translate }}</a
                  >
                </div>
              }
            }
            <!-- show tax refund related transaction for refund-->

            @if (showDetailsTopBorder()) {
              <div class="transaction-list-detail__border"></div>
            }

            @if (showDetailSlate()) {
              <div class="transaction-list-detail__content">
                <div class="mod-info">
                  <span>{{ tradeMessage | translate }}</span>
                  <span class="color-text button-weight transaction-list-detail__content__right">
                    <ng-content select="[amountExchanged]"></ng-content>
                  </span>
                </div>
                @if (transaction?.hasTrade()) {
                  <div class="mod-exchange">
                    <ng-content select="[cryptoPrice]"></ng-content>
                    <ng-container [ngTemplateOutlet]="relatedTransaction"></ng-container>
                  </div>
                }
                @if (isTrxCryptoMerger() && !transaction.hasTrade()) {
                  <div class="mod-crypto-merger">
                    &#64; 1 {{ transaction.getCryptoCoinSymbol() }} =
                    {{
                    mergerUnitPrice
                    | fiat_precision_symbol
                    : {
                    id: fiat?.getId(),
                    prefix: false,
                    symbol: true,
                    currencies: [fiat]
                  }
                  }}
                  <ng-container [ngTemplateOutlet]="relatedTransaction"></ng-container>
                </div>
              }
              @if (showFee()) {
                <div class="mod-withdraw">
                  <ng-content select="[sendFee]"></ng-content>
                </div>
              }
              <!-- show tax refund related transaction for sell-->
              @if (showTaxRefundRelatedTx$ | async; as taxRefundRelatedTx) {
                @if (
                  taxRefundRelatedTx?.enabled &&
                  taxRefundRelatedTx?.type === 'sell' &&
                  transactionType !== 'swap'
                  ) {
                  <div
                    class="mod-exchange"
                    >
                    <a
								(click)="
									openTaxRefundRelatedTx(
										taxRefundRelatedTx?.fiatWalletId,
										taxRefundRelatedTx?.relatedTxId
									)
								"
                      >{{ "swap_show_more_tx_item" | translate }}</a
                      >
                    </div>
                  }
                }
                <!-- show tax refund related transaction for sell-->
              </div>
            } @else {
              @if (transaction?.hasDebitCardRelatedTx()) {
                <div class="transaction-list-detail__content">
                  <div class="mod-exchange">
                    <ng-container [ngTemplateOutlet]="relatedTransaction"></ng-container>
                  </div>
                </div>
              }
            }
            <ng-template #relatedTransaction>
              <ng-content select="[relatedTx]"></ng-content>
            </ng-template>

            <div
              class="transaction-list-detail__total-amount"
					[ngClass]="{
						'mod-padding': !showDetailSlate() && !transaction?.hasDebitCardRelatedTx()
					}">
              <div>{{ "amount_total" | translate }}:</div>
              <div class="transaction-list-detail__total-amount__right">
                <ng-content select="[amountTotal]"></ng-content>
              </div>
            </div>
          </div>
        </div>
        @if (isRealSecurities()) {
          <div class="rs-banner">
            <real-securities-banner
              [title]="'inline_banner_real_securities_tax_title' | translate"
              [subtitle]="'inline_banner_real_securities_coming_soon_web' | translate" />
          </div>
        }
        @if (isCorporateAction()) {
          <div class="rs-banner">
            <real-securities-banner
              [title]="'inline_banner_real_securities_transaction_history_title' | translate"
              [subtitle]="'go_to_mobile_app_cta' | translate" />
            </div>
          }
        </ng-container>
      }

      <ng-template #capitalGains let-value="value">
        <span class="mod-flex-75 tax-amount">{{
          value
          | fiat_precision_symbol: { id: getTax()?.fiat_id.toString(), symbol: true }
          | value_change_prefix: { isProfit: value >= 0 }
        }}</span>
      </ng-template>

      <ng-template #isError>
        <span>{{ "failed_to_load" | translate }}</span>
        <span (click)="getCapitalGainModel()" class="mod-wallet-link">&nbsp;{{ "try_again" | translate }}</span>
      </ng-template>
